import React from "react";
import { useHealthcareCampaignComingSoon } from "../../hooks/useHealthcareCampaignComingSoon";
import CampaignFeatureComingSoon from "./CampaignFeatureComingSoon";

const HealthcareAiCampaignGate = ({ pageTitle, children }) => {
  const showComingSoon = useHealthcareCampaignComingSoon();

  if (showComingSoon) {
    return <CampaignFeatureComingSoon pageTitle={pageTitle} />;
  }

  return children;
};

export default HealthcareAiCampaignGate;
